import { ComponentSingleStyleConfig } from '@chakra-ui/theme/dist/types/theme.types';

export const MenuList: ComponentSingleStyleConfig = {
  variants: {
    'chakraSelect.MenuList': {},
  },
};
